type TokenGetter = () => Promise<string>;
type SessionEnder = () => void;

let _getAccessToken: TokenGetter | null = null;
let _endSession: SessionEnder | null = null;

export function setTokenAccessor(fn: TokenGetter): void {
  _getAccessToken = fn;
}

export function setSessionEnder(fn: SessionEnder): void {
  _endSession = fn;
}

export async function getAccessToken(): Promise<string> {
  if (_getAccessToken) {
    try {
      return await _getAccessToken();
    } catch (error) {
      console.warn(
        "[tokenAccessor] Failed to get token from WorkOS:",
        error
      );
    }
  }

  throw new Error("No access token available - user not authenticated");
}

export function endSession(): void {
  if (_endSession) {
    _endSession();
  } else {
    console.warn("[tokenAccessor] No session ender set, falling back to /login");
    window.location.href = "/login";
  }
}
